import styled from "styled-components"
import BellCharacter from "images/character/bell-54x46.png"
import ToggleButton from "components/presenters/button/ToggleButton"

export default function NotificationBar({ visible, checked, onChange, ...rest }) {
  return visible === true ? (
    <BarWrapper {...rest}>
      <BarLeft>
        <NotiImgWrapper>
          <NotiImg src={BellCharacter} />
        </NotiImgWrapper>
        <BarSeparator />
        까먹지 않도록 알람 보내드려요
      </BarLeft>
      <BarRight>
        <ToggleButton onChange={onChange} checked={checked} />
      </BarRight>
    </BarWrapper>
  ) : null
}
const BarWrapper = styled.form`
  display: flex;
  justify-content: space-between;
  background: white;
  padding: calc(100vw * (16 / 375)) calc(100vw * (16 / 375)) calc(100vw * (14 / 375))
    calc(100vw * (14 / 375));
  border-radius: calc(100vw * (12 / 375));
`
const NotiImgWrapper = styled.div`
  display: inline-block;
  width: calc(100vw * (27 / 375));
  height: calc(100vw * (23 / 375));
`
const NotiImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
const BarSeparator = styled.div`
  height: 100%;
  width: 1px;
  background: #c4c4c4;
  margin-left: calc(100vw * (11 / 375));
  margin-right: calc(100vw * (12 / 375));
  display: inline-block;
`
const BarLeft = styled.div`
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: 158.5%;
  color: #000000;
`
const BarRight = styled.div``
